import { CustomListItemApi, WebApiCustomListsDtoChangeCustomListItemMembersDto, WebApiCustomListsDtoCreateBulkCustomListDto, WebApiCustomListsDtoCreateCustomListItemDto, WebApiCustomListsDtoCustomListItemDto } from "../Repository/eventbookyapi";
import { GetApiConfiguration } from "./ServiceConfiguration";
import { WebApiCustomListsDtoUpdateCustomListItemDto } from "../Repository/eventbookyapi";

export abstract class CustomListItemService {
    public static GetItems = async (listId: number) => {
        return new CustomListItemApi(GetApiConfiguration()).apiCustomListItemListCustomListIdGet({ customListId: listId });
    };

    public static CreateCustomListItem = async (newItem: WebApiCustomListsDtoCreateCustomListItemDto) => {
        return new CustomListItemApi(GetApiConfiguration()).apiCustomListItemCreatePost({ webApiCustomListsDtoCreateCustomListItemDto: newItem });
    };

    public static CreateBulkCustomItems = async (newItems: WebApiCustomListsDtoCreateBulkCustomListDto) => {
        return new CustomListItemApi(GetApiConfiguration()).apiCustomListItemBulkCreatePost({ webApiCustomListsDtoCreateBulkCustomListDto: newItems });
    };

    public static DeleteCustomListItem = async (itemId: number) => {
        return new CustomListItemApi(GetApiConfiguration()).apiCustomListItemIdDelete({ id: itemId });
    };

    public static ChangeMembershipConnection = async (itemId: number, dto: WebApiCustomListsDtoChangeCustomListItemMembersDto) => {
        return new CustomListItemApi(GetApiConfiguration()).apiCustomListItemCustomListItemIdMembersPost({
            customListItemId: itemId,
            webApiCustomListsDtoChangeCustomListItemMembersDto: dto
        });
    }

    // Alias for better clarity
    public static ChangeCustomListItemMembers = CustomListItemService.ChangeMembershipConnection;

    public static UpdateCustomListItem = async (itemId: number, updateDto: WebApiCustomListsDtoUpdateCustomListItemDto) => {

        return new CustomListItemApi(GetApiConfiguration()).apiCustomListItemUpdateIdPost({
            id: itemId,
            webApiCustomListsDtoUpdateCustomListItemDto: updateDto
        });
    };
}


